import React from 'react';
import { cssUrl } from '../utils/imageUrl';
import { cropMediaStyle } from '../lib/collectionHeaders';
import './CollectionHero.css';

function CollectionHero({
  eyebrow,
  title,
  lede,
  imageUrl,
  crop,
  tone = '#1a1a1a',
}) {
  return (
    <section
      className="collection-hero"
      data-topbar-surface="dark"
      style={{ backgroundColor: tone }}
    >
      {imageUrl ? (
        <div
          className="collection-hero-media"
          style={{
            backgroundImage: cssUrl(imageUrl),
            ...cropMediaStyle(crop),
          }}
          aria-hidden="true"
        />
      ) : (
        <div className="collection-hero-empty" aria-hidden="true">
          <p className="collection-hero-wordmark">{title}</p>
        </div>
      )}
      <div className="collection-hero-shade" aria-hidden="true" />
      <div className="collection-hero-copy">
        {eyebrow ? <p className="collection-hero-eyebrow">{eyebrow}</p> : null}
        <h1 className="collection-hero-title">{title}</h1>
        {lede ? <p className="collection-hero-lede">{lede}</p> : null}
      </div>
    </section>
  );
}

export default CollectionHero;
